import type { Client } from "../client";
import type { PerformanceConfigurationResource } from "../resources/performanceConfigurationResource";
import { ConfigurationRepository } from "./configurationRepository";

export class PerformanceConfigurationRepository extends ConfigurationRepository<PerformanceConfigurationResource> {
    constructor(client: Client) {
        super("PerformanceConfiguration", client);
    }
}
